module.exports = __webpack_public_path__ + "img/ferrari.b87639d7.jpg";